import styled from "@emotion/styled";
import { Popover } from "react-aria-components";

export const StyledPopover = styled(Popover)<{ $styling: boolean }>`
  ${({ $styling, theme }) =>
    $styling &&
    `
  background: ${theme.colors.surface.popover};
  border-radius: ${theme.borderRadius.large};
  box-shadow: ${theme.shadows.surface};
  padding: ${theme.spacing["4"]};
`}
`;
